import { FC } from 'react';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { shallowEqual, useSelector } from 'react-redux';
import { SmartGridToken } from '@components/smart-grid-token';
import { ONE_MINUTE_MILLIS } from '@constants';
import { RootState } from '@state/store';
import { customFloor } from '@utils/math';

const Filters = dynamic(() => import('@components/explore-filter'), { ssr: false });

const Explore: FC = () => {
  const router = useRouter();

  const { appearance } = useSelector(
    (state: RootState) => state.settings,
    (left, right) => shallowEqual(left.appearance, right.appearance)
  );
  const startTime = customFloor(Date.now(), ONE_MINUTE_MILLIS);

  // const query = Object.keys(router.query)
  //   .map((key) => `${key}=${router.query[key]}`)
  //   .filter((param: string) => param.split('=')[1] !== '') // if a param has no fields after = dont add it
  //   .join('&');

  return (
    <>
      <Head>
        <title>Explore</title>
      </Head>

      <main>
        <Filters />
        <SmartGridToken
          api="/api/search/token"
          query={router.query}
          limit={30}
          masonry={appearance.masonry}
          info={appearance.info}
          market={appearance.market}
          labels={appearance.labels}
          maxtime={startTime}
        />
      </main>
    </>
  );
};

export default Explore;

export const getServerSideProps: GetServerSideProps = async ({ res, locale }) => {
  res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate');
  return {
    props: {
      messages: await import(`../../locales/${locale}.json`).then((e) => e.default),
    },
  };
};
